import axios from 'axios'
import {
	ElMessage
} from 'element-plus'
import {
	reset,
	getPathName,
	getFilterUrl,
	setMessageQueue,
	getParentPathName,
	globalCacheDeleteNoPermissionApi
} from '@/utils/common'
import router from '@/router'
import defaultSettings from '@/settings'
import useUserStore from '@/store/modules/user'

const request = axios.create({
	// 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
	baseURL: defaultSettings.systemLinkApi,
	// timeout: 60000,
	// withCredentials: true
})

// 20260902 将代码移动位置到顶部 统一全局定义
function getRouteInfo() {
	const route = router.currentRoute.value
	const path = route.path
	const query = route.query
	const currentUrl = getPathName() // 假设它基于 window.location 或路由
	const parUrl = getParentPathName(path.replace('/', ''))
	const filterUrlPar = parUrl || currentUrl

	// 20260423 新增根据菜单查对应权限功能
	let filterUrl = ''
	if (query.pageType || query.type || query.params || query.id || query.templateId) {
		// 特殊页面 获取父级菜单
		filterUrl = getFilterUrl(path, query.pageType, query.type, query.params ? JSON.parse(query.params)
			.path : '', query.id)
		console.log(filterUrl, 'filterUrl')
	}

	const filterUrlHeader = filterUrl || (filterUrlPar ? '/' + filterUrlPar : '')

	return {
		currentUrl,
		filterUrlHeader
	}
}

// 清掉项目需求缓存
function cacheDelete(response) {
	console.log(response.config && response.config.headers['filter-url'], 'ppp')

	// 延时调用清缓存接口（整个菜单大类）
	if (response.config && response.config.headers['filter-url']) {
		globalCacheDeleteNoPermissionApi(response.config.headers['filter-url'].replace('/', ''))
	}
}

let configObj = {}
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
	// console.log(config, 'config')
	config.metadata = {
		startTime: Date.now()
	};
	config.timeout = config.url === 'home/search/checkSearch' ? 60000 : 15000;

	configObj = config
	console.log(configObj, 'configObjconfigObj')

	// 20260902 新增注释
	// const routeData = router.currentRoute.value
	// const path = routeData.path
	// const query = routeData.query

	if (config.url === 'sys/file/upload/file' || config.url === 'sys/file/upload/file/service/station') {
		config.headers['Content-Type'] = 'multipart/form-data'
	} else {
		config.headers['Content-Type'] = 'application/json;charset=utf-8'
	}
	if (localStorage.getItem('token')) {
		config.headers['token'] = localStorage.getItem('token')
	}

	// 20251126 新增顶号后 加载最新的用户
	if (localStorage.getItem('userInfo') && JSON.stringify(useUserStore().userInfo) !== '{}') {
		const userInfo = JSON.parse(localStorage.getItem('userInfo'))
		if (userInfo.id !== useUserStore().userInfo.id) {
			useUserStore().userInfo = userInfo
		}
	}

	// 20260902 新增注释
	// // 20260423 新增根据菜单查对应权限功能
	// let filterUrl = ''
	// if (query.pageType || query.type || query.params || query.id || query.templateId) {
	// 	// 特殊页面 获取父级菜单
	// 	filterUrl = getFilterUrl(path, query.pageType, query.type, query.params ? JSON.parse(query.params)
	// 		.path : '', query.id)
	// 	console.log(filterUrl, 'filterUrl')
	// }

	// 20260902 新增注释
	// // 子级查对应的父级菜单
	// const parUrl = getParentPathName(path.replace('/', ''))
	// // 当前菜单路由
	// const currentUrl = getPathName()
	// const filterUrlPar = parUrl || currentUrl

	// 路由相关（此时才访问 router，避免循环依赖）
	const {
		filterUrlHeader
	} = getRouteInfo()
	console.log(filterUrlHeader, 'getRouteInfo')

	// 新增父级菜单
	config.headers['filter-url'] = filterUrlHeader

	return config
}, error => {
	return Promise.reject(error)
})

let num = 0

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
	response => {
		let res = response.data
		let responseType = response.config.responseType
		// 如果是返回的文件
		if (responseType === 'blob' || responseType === 'arraybuffer') {
			return response
		}

		// 兼容服务端返回的字符串数据
		// if (typeof res === 'string') {
		// 	res = res ? JSON.parse(res) : res
		// }

		if (response.headers['token']) {
			let token = response.headers['token'] || ''
			localStorage.setItem('token', token)
		}
		// console.log(response, response.headers, 11112)
		// if (configObj.url.includes('sys/sysuser/order/downLoad')) {
		// 	var blob = new Blob([res], {
		// 		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
		// 	});
		// 	let downloadElement = document.createElement('a');
		// 	let href = window.URL.createObjectURL(blob); //创建下载的链接
		// 	downloadElement.href = href;
		// 	// decodeURI 解决中文乱码问题 与后端配合解码
		// 	if (response.headers['content-disposition']) {
		// 		let str = response.headers['content-disposition'].split('.')[0]
		// 		downloadElement.download = !isNaN(str) ? response.headers['content-disposition'] : decodeURI(
		// 			response.headers['content-disposition']); //下载后文件名
		// 		document.body.appendChild(downloadElement);
		// 		downloadElement.click(); //点击下载
		// 		document.body.removeChild(downloadElement); //下载完成移除元素
		// 		window.URL.revokeObjectURL(href); //释放掉blob对象
		// 		return res
		// 	} else {
		// 		console.log(response, 'response')
		// 		return Promise.reject('未知异常，请联系管理员')
		// 	}
		// } else {

		console.log(configObj, res, 'configObjconfigObj resres')

		if (res.code === 401) {
			num++
			if (num === 1) {
				ElMessage({
					message: '请登录',
					type: 'warning',
					offset: 68
				})
			}

			setTimeout(() => {
				// 重置登录状态并进入去登录页
				reset('401')
			}, 500)
		} else if (res.code === 4004) {
			// 路由跳转页面不存在 跳回到首页并且强制刷新当前系统
			return res
		} else if (res.code === 500) {
			// 补充 除了以下接口外  只要返回不存在即重载页面
			const noRefreshData = ['sys/sysuser/checkUserNameCanWork', 'sys/sysuser/checkUserNameCanWork']

			// 不需要重载
			// archiveSetting--1、archiverecordtype/updateTypeBatch  2、archivestage/updateStageBatch 

			const index = noRefreshData.findIndex(val => {
				console.log(val.includes(configObj.url), 'pppp', val, configObj.url)
				return val.includes(configObj.url)
			})
			console.log(index, 'pppp index')

			let customMsg = res.msg

			// 补充500 并且返回不存在时 缓存数据为了刷新/跳转页面
			if (customMsg.includes('不存在') && index === -1) {
				// 20260908 强制修改提示语为  检测数据不存在，等待刷新后尝试！
				customMsg = '检测数据不存在，等待刷新后尝试！'

				const {
					currentUrl,
					filterUrlHeader
				} = getRouteInfo()

				// 子级菜单调用 跳转会上一级页面 并且不是
				if (('/' + currentUrl) !== filterUrlHeader) {
					// 返回500时 后端进行缓存统一清除（同code5002）

					// 清除/重置对应的标识 使得返回到父级时 父级可以自行刷新页面
					localStorage.removeItem('submitType')
					localStorage.removeItem('refreshPage')
					localStorage.setItem('EnterprisedetailsDataType', 'add')

					if (window.history.state && window.history.state.back) {
						// 如果有，则返回上一页
						router.back();
					} else {
						// 如果没有，则跳转到指定页面，比如上一级菜单
						// 使用 replace 避免在历史记录中留下过多痕迹
						router.replace({
							path: filterUrlHeader
						});
					}
				} else {
					// 列表页等父级菜单接口
					localStorage.setItem('code5002Refresh', filterUrlHeader || '__ALL__')
				}
			}

			return Promise.reject(customMsg || '网络错误，请重新加载')
		} else if (res.code === 5002) {
			// 20260909 优化 5002时 强制修改提示语为以下内容  检测数据不存在，等待刷新后尝试！
			let customMsg = '检测数据不存在，等待刷新后尝试！'

			// 20260921 新增 站内信弹窗提示不存在时的判断
			if (localStorage.getItem('noticeDrawerShow')) {
				return Promise.reject(customMsg)
			}

			// 20260907新增  5002数据不存在时 详情页时回到上一级页面/父级页面时在当前页面刷新数据（重载功能 后端清除缓存）
			// 当前菜单路由currentUrl  父级菜单filterUrlPar
			const {
				currentUrl,
				filterUrlHeader
			} = getRouteInfo()

			// 补充 当前页面是enterprisedetailsDataPage 并且返回不存在时 与移除/注销 和部门/组织不存在进行区分
			if (currentUrl === 'enterprisedetailsDataPage' && res.msg.includes('当前企业不存在')) {
				localStorage.setItem('noFound', 'noFound')
			}

			console.log(('/' + currentUrl) !== filterUrlHeader && currentUrl !== 'enterprisedetailsDataPage',
				'20260909 pppp')

			// 20260910 补充 定制路径编辑 提示异常并且路径为pathInformationEdit时 不走公共详情页跳转方法
			const pathInformationEditNoJump = !(currentUrl === 'pathInformationEdit' && (res.msg.includes(
				'检测数据存在变化') || res.msg.includes('检测配置数据变动')))

			// 子级菜单调用 跳转会上一级页面 并且不是
			// 20260909 新增 如果在企业运维--企业详情列表页的详情按钮等调用时 不跳转会上一级 仅在当前页面刷新  currentUrl !== 'enterprisedetailsDataPage'
			if (('/' + currentUrl) !== filterUrlHeader && currentUrl !== 'enterprisedetailsDataPage' &&
				pathInformationEditNoJump) {
				// 返回5002时 后端进行缓存统一清除

				// 20260910补充 项目部分已有特殊处理方法  需放行项目追踪部分
				if (filterUrlHeader !== '/projectCenter' && filterUrlHeader !== '/myToDo' && filterUrlHeader !==
					'/myCreate' && filterUrlHeader !== '/itemsRequiringAssistance') {
					// 清除/重置对应的标识 使得返回到父级时 父级可以自行刷新页面
					localStorage.removeItem('submitType')
					localStorage.removeItem('refreshPage')
					localStorage.setItem('EnterprisedetailsDataType', 'add')

					if (window.history.state && window.history.state.back) {
						// 如果有，则返回上一页
						router.back();
					} else {
						// 如果没有，则跳转到指定页面，比如上一级菜单
						// 使用 replace 避免在历史记录中留下过多痕迹
						router.replace({
							path: filterUrlHeader
						});
					}
				}

				// 项目部分调用接口时  project返回true false
				if (typeof res?.project === 'boolean') {
					return Promise.reject([customMsg || '', res.project || ''])
				} else {
					// 除项目外其他接口返回提示时 不返回project
					return Promise.reject(customMsg)
				}
			} else {
				// 20260910 定制路径编辑 补充提示语用后端返回的
				if (currentUrl === 'pathInformationEdit') {
					customMsg = res.msg
				}

				// 列表页等父级菜单接口
				localStorage.setItem('code5002Refresh', filterUrlHeader || '__ALL__')

				// 项目部分调用接口时  project返回true false
				if (typeof res?.project === 'boolean') {
					return Promise.reject([customMsg || '', res.project || ''])
				} else {
					// 除项目外其他接口返回提示时 不返回project
					return Promise.reject(customMsg)
				}
			}
		} else if (res.code == 501) {
			return res
		} else if (res.code == 503) {
			// 无查看权限 直接返回首页
			setTimeout(() => {
				router.replace('/')
			}, 100)

			// 清掉当前菜单对应的缓存
			cacheDelete(response)

			return Promise.reject(res.msg)
		} else if (res.code == 5034) {
			// 20260902新增code相关
			// 项目--未参与项目时  综合档案--未参与 父级菜单调用 不跳转页面  子级菜单调用 跳转回上一级页面（不用重载页面）
			// 20260902新增 当前菜单路由currentUrl  父级菜单filterUrlPar
			const {
				currentUrl,
				filterUrlHeader
			} = getRouteInfo()

			console.log(currentUrl, filterUrlHeader, configObj.url, 'currentUrl, filterUrlHeader')
			// powerabout调用时 额外处理
			if (configObj.url == 'tracking/projecttrackingproject/powerAbout') {
				return res
			} else {
				// 子级菜单调用 跳转会上一级页面
				if (('/' + currentUrl) !== filterUrlHeader) {
					// 清除当前菜单对应的缓存
					cacheDelete(response)

					if (window.history.state && window.history.state.back) {
						// 如果有，则返回上一页
						router.back();
					} else {
						// 如果没有，则跳转到指定页面，比如上一级菜单
						// 使用 replace 避免在历史记录中留下过多痕迹
						router.replace({
							path: filterUrlHeader
						});
					}

					return Promise.reject(res.msg)
				} else {
					// 仅给提示 不跳转页面
					setMessageQueue('error', res.msg)
					return
				}
			}

			return res
		} else if (res.code == 505) {
			// powerabout 的返回
			return res
		} else if (res.code === 200) {
			// // 1. 特性检测：确保 API 存在
			// const connection = navigator.connection || {};
			// let connectionData = null

			// if (!connection) {
			// 	console.warn('当前浏览器不支持 navigator.connection API');
			// } else {
			// 	connectionData = {
			// 		type: connection.type,
			// 		effectiveType: connection.effectiveType,
			// 		rtt: (connection.rtt || '未知') + 'ms',
			// 		downlink: connection.downlink,
			// 		saveData: connection.saveData
			// 	}

			// 	// 2. 主动打印当前网络状态（页面加载时）
			// 	console.log(`[初始] 网络类型: ${connection.effectiveType || '未知'}, RTT: ${connection.rtt || '未知'}ms`);
			// }

			// const errorTip = {
			// 	error: JSON.stringify(error),
			// 	time: Date.now(),
			// 	api: configObj.url,
			// 	connectionData: connectionData ? JSON.stringify(connectionData) : '',
			// 	// 记录当前时间与请求开始时间的差值
			// 	elapsedTime: Date.now() - (error.config?.metadata?.startTime || 0)
			// }

			// console.log(errorTip, 'errorTip')

			return res
		}
		// }
		// if (status === 401) store.dispatch('FedLogOut').then(() => router.push({path: '/login'}));
	},
	error => {
		if (configObj.url !== '/message/getUnReadMessage' && configObj.url !== '/order/get' && configObj.url !==
			'/order/pay') {
			ElMessage({
				message: '网络错误，请重新加载' + configObj.url,
				type: 'info' // error => info 合并成一个提示样式
			})
		}

		// 1. 特性检测：确保 API 存在
		const connection = navigator.connection || {};
		let connectionData = null

		if (!connection) {
			console.warn('当前浏览器不支持 navigator.connection API');
		} else {
			connectionData = {
				type: connection.type,
				effectiveType: connection.effectiveType,
				rtt: (connection.rtt || '未知') + 'ms',
				downlink: connection.downlink,
				saveData: connection.saveData
			}
			// 2. 主动打印当前网络状态（页面加载时）
			console.log(`[初始] 网络类型: ${connection.effectiveType || '未知'}, RTT: ${connection.rtt || '未知'}ms`);
		}

		const errorTip = {
			error: JSON.stringify(error),
			time: Date.now(),
			api: configObj.url,
			connectionData: connectionData ? JSON.stringify(connectionData) : '',
			// 记录当前时间与请求开始时间的差值
			elapsedTime: Date.now() - (error.config?.metadata?.startTime || 0)
		}

		console.log(errorTip, 'errorTip')

		localStorage.setItem('errorLocalStorage', JSON.stringify(errorTip))

		console.log('err' + error) // for debug

		return Promise.reject(error)
	}
)

export default request